import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import * as fromRoot from '@app/store/index';
import { selectSignalGeneratorType } from '@app/store/signal-generator.actions';
import { SignalGeneratorType } from '@app/store/signal-generator.model';

@Injectable({
  providedIn: 'root',
})
export class SignalGeneratorService {
  private store$ = inject<Store<fromRoot.AppState>>(Store);

  selectedSignalGeneratorType$ = this.store$.select(fromRoot.selectSelectedSignalGeneratorType);

  selectSignalGeneratorById(signalGeneratorId: string) {
    return this.store$.select(fromRoot.createSignalGeneratorByIdSelector(signalGeneratorId));
  }

  selectSignalGeneratorType(signalGeneratorType: SignalGeneratorType) {
    this.store$.dispatch(selectSignalGeneratorType({ signalGeneratorType }));
  }

  selectSignalGeneratorsByTuningControllerId(tuningControllerId: string) {
    return this.store$.select(fromRoot.createSignalGeneratorsByTuningControllerIdSelector(tuningControllerId));
  }
}
